import React, { Component } from 'react';
import { loadScript } from '@ecs/tng-common/scripts/helpers';
import { QSWidgetClassNames, SGWidgetTypes } from '../../helpers/interfaces';

interface SGWidgetProps {
  sgWidget: SGWidgetTypes;
  className?: QSWidgetClassNames;
  postData: {
    id: string;
    catSlug: string;
    catId: string;
    isSEMtemplate: boolean;
  };
}
interface IWidgetData {
  title: string;
  type: string;
}
interface SGWidgetTypeState {
  scriptLoaded: boolean;
}
const widgetConfiguration: Record<SGWidgetTypes, IWidgetData> = {
  purchase: {
    title: 'Compare rates on a new auto loan',
    type: 'sg-purchase'
  },
  refinance: {
    title: 'Compare rates on auto refinance',
    type: 'sg-refinance'
  },
  leaseBuyout: {
    title: 'Compare rates on lease buyout',
    type: 'sg-lease'
  }
};
class SGWidget extends Component<SGWidgetProps, SGWidgetTypeState> {
  widget: IWidgetData = widgetConfiguration[this.props.sgWidget];

  constructor(props: SGWidgetProps) {
    super(props);
    this.state = {
      scriptLoaded: false
    };
  }

  componentDidMount() {
    if (typeof window !== 'undefined' && this.widget) {
      this.initializeWidget();
    }
  }

  componentWillUnmount() {
    // Cleanup scripts on unmount
    const el = document.getElementById('savings-async');
    if (el) {
      document?.head?.removeChild(el);
    }
  }

  getCookie = (name: string) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop()?.split(';').shift();
    return '';
  };

  getQueryParams = () => {
    const params = new URLSearchParams(window.location.search);
    return {
      conf: params.get('conf') || '',
      mkid: params.get('mkid') || ''
    };
  };

  toApplyUITreatment = () => {
    const { isSEMtemplate, catSlug } = this.props.postData;
    const { className } = this.props;
    let toApplyUITreatment: boolean = true;

    if (isSEMtemplate || catSlug === 'lp') {
      toApplyUITreatment = false;
    }
    if (className === 'qs-widget-background') {
      toApplyUITreatment = true;
    }
    if (toApplyUITreatment && className === 'qs-widget-no-background') {
      toApplyUITreatment = false;
    }
    return toApplyUITreatment;
  };

  initializeWidget() {
    const queryParams = this.getQueryParams();
    const mkid =
      queryParams.mkid || this.getCookie('marketingid') || '00000000-0000-0000-0000-000000000000';
    let counter = 0;
    const int = setInterval(() => {
      if (window.ECS?.tms?.data) {
        clearInterval(int);
        const v2 = {
          id: this.props.postData.id ? `id:${this.props.postData.id}` : '',
          cat: this.props.postData.catSlug ? `|cat:${this.props.postData.catSlug}` : '',
          pc: window.ECS?.tms?.data.pc ? `|pc:${window.ECS?.tms?.data.pc}` : '',
          cc: window.ECS?.tms?.data.cc ? `|cc:${window.ECS?.tms?.data.cc}` : '',
          mkid: `|mkid:${mkid}`,
          conf: queryParams.conf ? `|conf:${queryParams.conf}` : ''
        };
        window.THE_SAVINGS_GROUP_EXPERIENCES_CONFIGURATION = {
          configurationCode: 'EXPERIAN_WIDGET',
          experiences: [
            {
              name: 'rate-calculator',
              targetSelector: '#savingsgroup',
              uniqueIdentifier: `${v2.id}${v2.cat}${v2.pc}${v2.cc}${v2.conf}${v2.mkid}`,
              rateCalculator: {
                padding: false,
                backgroundColor: 'transparent',
                primaryColor: '#c1188b',
                secondaryColor: '#2a5595',
                showResults: true,
                loanAmount: '',
                creditTier: '',
                loanTerm: '',
                loanType: this.props.sgWidget
              }
            }
          ]
        };
        this.load();
      } else if (counter > 15) {
        clearInterval(int);
      }
      counter++;
    }, 100);
  }

  load() {
    const scriptSrc = `${process.env.SAVINGS_HOST}`;
    const scriptId = 'savings-async';
    loadScript(scriptSrc, scriptId)
      .then(() => {
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.addedNodes.length > 0) {
              const iframe = document.querySelector('#savingsgroup iframe') as HTMLIFrameElement;
              if (iframe) {
                iframe.addEventListener('load', () => {
                  this.setState({ scriptLoaded: true });
                });
                observer.disconnect();
              }
            }
          });
        });
        observer.observe(document.getElementById('savingsgroup')!, { childList: true });
      })
      .catch((error) => {
        console.error(error);
      });
  }

  render() {
    if (!this.widget) return null;
    const toApplyUITreatment = this.toApplyUITreatment();
    return (
      <div
        className={`${this.state.scriptLoaded ? 'bg-light content-mt mb-4 mb-lg-5 rounded px-3 px-lg-4 pb-lg-2' : ''} ${this.state.scriptLoaded && toApplyUITreatment ? 'pt-4 pt-lg-6 ' : 'pt-lg-2'}`}>
        {this.state.scriptLoaded && toApplyUITreatment ? (
          <h3 className="mb-2">{this.widget.title}</h3>
        ) : null}
        <div id="savingsgroup" />
      </div>
    );
  }
}

export default SGWidget;
